"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaStyles = exports.MediaContextProvider = exports.Media = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _fresnel = require("@artsy/fresnel");
var _constants = require("../constants");
var AppMedia = (0, _fresnel.createMedia)({
  // breakpoints values can be either strings or integers
  breakpoints: (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.BREAKPOINTS.XXS, 0), _constants.BREAKPOINTS.XS, _constants.BREAKPOINTS.XS), _constants.BREAKPOINTS.SM, _constants.BREAKPOINTS.SM), _constants.BREAKPOINTS.MD, _constants.BREAKPOINTS.MD), _constants.BREAKPOINTS.LG, _constants.BREAKPOINTS.LG), _constants.BREAKPOINTS.XL, _constants.BREAKPOINTS.XL),
  interactions: {
    hover: "(hover: hover)",
    notHover: "(hover: none)",
    landscape: "not all and (orientation: landscape)",
    portrait: "not all and (orientation: portrait)"
  }
});

// Make styles for injection into the header of the page
var mediaStyles = exports.mediaStyles = AppMedia.createMediaStyle();
var Media = exports.Media = AppMedia.Media,
  MediaContextProvider = exports.MediaContextProvider = AppMedia.MediaContextProvider;